import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';
import { useConfirmationStore } from '@/components/dialog/confirmation.store';
import { useDynamicLocale } from '@/hoslog-intl';
import { Pagination } from '@/react-query/context/ApiClientContextController';
import { Affiliate } from '@/services/affiliate/affiliate.types';
import * as React from 'react';
import useAffiliateStatus from '../hooks/useAffiliateStatus';
import useResetPassword from '../hooks/useResetPassword';
import { getColumns } from './Column';

export function AffiliateTable({
  data,
  isLoading = false,
  pagination,
}: {
  data: Affiliate[];
  isLoading: boolean;
  pagination: Pagination;
}) {
  const { openConfirmation } = useConfirmationStore();
  const { mutateAsyncResetPassword } = useResetPassword();
  const { mutateAsyncAffilateStatus } = useAffiliateStatus();
  const { t } = useDynamicLocale();

  const pageCount = React.useMemo(
    () => Math.ceil((pagination.totalItems ?? 0) / (pagination.pageSize ?? 1)),
    [pagination.totalItems, pagination.pageSize],
  );

  const columns = React.useMemo(
    () =>
      getColumns({
        openConfirmation,
        mutateAsyncResetPassword,
        mutateAsyncAffilateStatus,
        t,
      }),
    [openConfirmation, mutateAsyncResetPassword, mutateAsyncAffilateStatus, t],
  );

  const { table } = useDataTable({
    data,
    columns,
    pageCount: pageCount,
    initialState: {
      sorting: [{ id: 'agentId', desc: true }],
    },
    meta: {
      title: t('userManagement.affiliates.table.title.affiliateList'),
      loading: isLoading,
      totalPage: pagination.totalItems,
    },
    getRowId: (originalRow) => String(originalRow.agentId),
    columnResizeMode: 'onChange',
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table}>
        <DataTableToolbar />
      </DataTable>
    </>
  );
}
